import React from "react";
import {
  DashboardHourlyBarChart,
  HourlyBarDatum,
} from "../DashboardHourlyBarChart";

interface DepartureChartProps {
  metricScale?: number;
  data?: HourlyBarDatum[];
}

export const DepartureChart: React.FC<DepartureChartProps> = ({
  metricScale = 0,
  data,
}) => {
  return (
    <DashboardHourlyBarChart
      primaryLabel="Departures"
      secondaryLabel="Pre Check-Outs"
      metricScale={metricScale}
      data={data}
    />
  );
};
